import { Cloud, FlaskConical, Server } from "lucide-react";

const MODES = [
  { key: "internal", icon: Server, title: "Studio (interno)", text: "I siti compilati sono visibili solo dallo Studio, sempre con noindex." },
  { key: "emulator", icon: FlaskConical, title: "Emulatore locale", text: "Cloudflare simulato su questo server (Worker, R2, KV). Solo per i test: nessun account, nessun costo." },
  { key: "cloudflare", icon: Cloud, title: "Cloudflare", text: "Il tuo account Cloudflare: i siti restano online anche con lo Studio spento." },
];

export default function ModePicker({ h, onPick }) {
  return (
    <div className="grid gap-3 md:grid-cols-3" role="radiogroup" data-testid="hosting-mode-picker">
      {MODES.map(({ key, icon: Icon, title, text }) => {
        const on = h.mode === key;
        const disabled = key === "emulator" && !h.emulator_available;
        return (
          <button key={key} type="button" role="radio" aria-checked={on} disabled={disabled} onClick={() => !on && onPick(key)}
            data-testid={`hosting-mode-${key}`}
            className={`group flex flex-col justify-start text-left rounded-xl border p-4 transition-[border-color,background-color,box-shadow] duration-200 disabled:opacity-50 ${on ? "border-sky-500 bg-sky-50/60 shadow-[0_0_0_3px_rgba(14,165,233,0.12)]" : "border-slate-200 bg-white hover:border-slate-300"}`}>
            <div className="flex items-center justify-between gap-2">
              <span className={`inline-flex h-9 w-9 items-center justify-center rounded-lg ${on ? "bg-sky-600 text-white" : "bg-slate-100 text-slate-600 group-hover:bg-slate-200"}`}><Icon size={17} /></span>
              {on && <span className="rounded-full bg-sky-600 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-white" data-testid="hosting-mode-current">In uso</span>}
            </div>
            <p className="mt-3 text-sm font-semibold text-slate-900">{title}</p>
            <p className="mt-1 text-xs leading-relaxed text-slate-500">{disabled ? "Non disponibile su questo server." : text}</p>
          </button>
        );
      })}
    </div>
  );
}
